//@ts-nocheck
import { Box } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NOOP_PROMISE } from '../../../const/CommonConst';

const PdfIframe = ({
  docDetails,
  downloadDocument,
  viewReport = NOOP_PROMISE,
}) => {
  const [pdfBlobUrl, setPdfBlobUrl] = useState('');
  const [pdfHeight, setPdfheight] = useState('calc(100vh - 330px)');

  const fetchPdf = useCallback(() => {
    // first case for report pdf
    if (docDetails?.report_id) {
      setPdfheight('100%');
      viewReport(
        { report_id: docDetails?.report_id },
        { responseType: 'blob' }
      ).then((response) => {
        const blob = new Blob([response.data], {
          type: 'application/pdf',
        });
        setPdfBlobUrl(URL.createObjectURL(blob));
      });
    } else {
      downloadDocument({
        params: {
          document_id: docDetails?.document_id,
          entity_id: docDetails?.entity_id,
          entity_type: docDetails?.entity_type,
        },
      }).then((response) => {
        if (response) {
          const blob = new Blob([response], {
            type: 'application/pdf',
          });
          setPdfBlobUrl(URL.createObjectURL(blob));
        }
      });
    }
  }, [docDetails, downloadDocument, viewReport]);

  useEffect(() => {
    if (docDetails) {
      fetchPdf();
    }
  }, [docDetails]);

  return (
    <Box
      sx={{
        width: '100%',
        height: pdfHeight,
      }}
    >
      {pdfBlobUrl && (
        <iframe
          title="pdf iframe"
          src={pdfBlobUrl}
          width="100%"
          height="100%"
        />
      )}
    </Box>
  );
};

PdfIframe.propTypes = {
  docDetails: PropTypes.oneOfType([PropTypes.object]).isRequired,
  downloadDocument: PropTypes.func.isRequired,
  viewReport: PropTypes.func,
};

export default PdfIframe;
